import { createFileRoute, Outlet } from "@tanstack/react-router";
import { PageShell } from "@/components/ui/page-shell";

/**
 * Layout for every /connectors/* surface: list, create, connector detail,
 * connection, and feed. This layout only provides shared page padding.
 *
 * It stays full-width; each page centres its own `ConnectorPageColumn`. The
 * rails this used to leave room for are gone, and the columns are centred
 * rather than flush-left.
 */
export const Route = createFileRoute("/$owner/connectors")({
	component: ConnectorsLayout,
});

function ConnectorsLayout() {
	return (
		// Comfortable page inset — not flush to the shell, not a tall empty band.
		<PageShell className="gap-3 pt-2.5 pb-8">
			<div className="flex min-h-0 min-w-0 flex-1 flex-col">
				<Outlet />
			</div>
		</PageShell>
	);
}
